import { useState } from "react";
import { Modal, Button } from "antd";

const DeleteUserConfirmation = ({
  user,
  onDeleteSuccess,
  deleteUser,
  notifyApi,
}) => {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    try {
      await deleteUser(user.uid);
      notifyApi.success({
        key: "user-delete-success",
        message: "User Deletion",
        description: `${user.firstName} ${user.lastName} deleted successfully`,
        duration: 3,
        showProgress: true,
        pauseOnHover: true,
      });
      onDeleteSuccess?.();
    } catch (err) {
      notifyApi.error({
        key: "user-delete-error",
        message: "Deletion Failed",
        description: "Failed to delete user. Please try again.",
        duration: 3,
        showProgress: true,
        pauseOnHover: true,
      });
      console.error("Delete error:", err);
    } finally {
      setConfirmLoading(false);
      setOpen(false);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        type="text"
        danger
        onClick={showModal}
        style={{ padding: "4px 0" }}
      >
        Delete
      </Button>

      <Modal
        title="Confirm Deletion"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        okText="Delete"
        okType="danger"
        cancelText="Cancel"
      >
        <p>
          Are you sure you want to delete {user.firstName} {user.lastName}?
        </p>
        <p style={{ color: "red" }}>This action cannot be undone.</p>
      </Modal>
    </>
  );
};

export default DeleteUserConfirmation;
